module.exports = __webpack_public_path__ + "static/media/edit-regular-no-color.2d7b16ef.svg";